// extracted by mini-css-extract-plugin
export default {"Error":"ListError_Error__g4gtK"};